import { render, staticRenderFns } from "./_SpareParts.vue?vue&type=template&id=72557eda&"
import script from "./_SpareParts.vue?vue&type=script&lang=js&"
export * from "./_SpareParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports